import axios, { AxiosResponse } from 'axios';

export const fetchmbed = (target: string): Promise<AxiosResponse<any, any>> => {
    if (typeof fetchedData !== 'undefined' && fetchedData[target] != null) {
        return Promise.resolve(fetchedData[target])
    }
    const res = axios(target)
    res.then((response) => {
        if (typeof fetchedData !== 'undefined' && fetchedData[target] != null) {
            return;
        }
        const el = document.createElement('script')
        el.type = 'text/javascript'
        el.innerHTML = `
            window.fetchedData = window.fetchedData || {};
            fetchedData['${target}'] = ${JSON.stringify(response)}
        `
        document.body.appendChild(el)
    })
    return res
};
